import React from 'react';

export const BackgroundVideo = ({
  className,
  src = 'https://storage.googleapis.com/shibuya-white-rabbit/landing-bg-animation-v2.mp4',
}: {
  className?: string;
  src?: string;
}) => {
  return (
    <video
      className={`${className} overlay-item fixed inset-0 -z-10 h-screen w-screen transform bg-black object-cover`}
      playsInline
      autoPlay
      muted
      loop
      preload="auto"
    >
      <source src={src} type="video/mp4" />
    </video>
  );
};

export default BackgroundVideo;
